import React, { FC } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import InfiniteScroll from 'react-infinite-scroll-component';
import { generatePath, Link } from 'react-router-dom';
import useStyles from './styles';
import CompaignItem from './CompaignItem';
import CompaignEmpty from './CompaignEmpty';
import { useGetCompaigns } from '../../hooks/queries/useGetCompaigns';

export const PAGE_SIZE = 10;

interface ICompaignsList {
  compaignId?: number;
}

const CompaignsList: FC<ICompaignsList> = (props) => {
  const { compaignId } = props;
  const classes = useStyles();

  const { data } = useGetCompaigns();

  if (!data?.compaigns?.compaigns?.length) return <CompaignEmpty />;

  return (
    <Box className={classes.wrapper}>
      <InfiniteScroll
        style={{ flexGrow: 1 }}
        dataLength={0}
        next={() => {}}
        hasMore={false}
        loader={<CircularProgress />}>
        {data?.compaigns?.compaigns?.map(
          (item, index) =>
            item && (
              <Link
                key={`compaign-item-link-${index}`}
                style={{ textDecoration: 'none' }}
                to={generatePath('/compaigns/:id', { id: item?.id })}>
                <CompaignItem
                  key={`compaign-item-${index}`}
                  active={item.id === compaignId}
                  item={item}
                />
              </Link>
            ),
        )}
      </InfiniteScroll>
    </Box>
  );
};

export default CompaignsList;
